export const isMac =
  typeof navigator === 'undefined' ? false : /(mac|iphone|ipod|ipad)/i.test(navigator.platform)
export const isWindows =
  typeof navigator === 'undefined' ? false : /(win32|win64)/i.test(navigator.platform)
export const isOther = !isMac && !isWindows

export const modifierKey = isMac ? '⌘' : 'Ctrl'
